import styled from "styled-components";

export const StyledContentSidebarMobile = styled.div`
    background-color: #FFFFFF;
`